<div
  class="toggle-container"
  [ngClass]="{ 'toggle-true': value, 'toggle-blue': isBlueDesign }"
  (click)="toggle()"
>
  <div class="toggle-button">
    @if (!isBlueDesign) {
      @if (value) {
        <app-svg-icon name="check"></app-svg-icon>
      }
      @if (!value) {
        <app-svg-icon name="close-red"></app-svg-icon>
      }
    }
  </div>
</div>
